import React, { useState, useEffect } from 'react';
import Login from './components/Login/index.js';
import Dashboard from './components/Dashboard/index.js';

const App = () => {
    const [user, setUser] = useState(null); // State to track the logged-in user

    // Check if the user is already logged in (using localStorage)
    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        const storedLoginTime = localStorage.getItem('loginTime');

        // Check if there is a stored user and a valid login time
        if (storedUser && storedLoginTime) {
            const currentTime = new Date().getTime(); // Current time in milliseconds
            const loginTime = parseInt(storedLoginTime);

            // If 5 hours have passed since login, remove the user from localStorage
            if (currentTime - loginTime > 5 * 60 * 60 * 1000) {
                localStorage.removeItem('user');
                localStorage.removeItem('loginTime');
                setUser(null); // Reset the user state
            } else {
                setUser(JSON.parse(storedUser)); // Set user data from localStorage
            }
        }
    }, []);

    // Function to handle successful login
    const handleLogin = (userData) => {
        setUser(userData); // Set user data after login (usually token or user info)
    };

    return (
        <div>
            {user ? (
                <Dashboard /> // If user is logged in, show the Dashboard
            ) : (
                <Login onLogin={handleLogin} /> // Otherwise, show the Login page
            )}
        </div>
    );
};

export default App;
